import React from 'react'
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import DialogContent from "@material-ui/core/DialogContent";
import CKEditor from "react-ckeditor-component";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import Session from "../../helpers/Session";

class MensajeGestor extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            mensaje: null
        };

    }

    onChangeCkEditor = (evt) => {
        const newContent = evt.editor.getData();
        this.setState({
            mensaje: newContent
        });
    }

    guardar = async () => {

        if (this.state.mensaje === null || this.state.mensaje === '') {
            AppToast('¡Debe ingresar el mensaje!', false);
            return;
        }

        const user = Session.getLogin();
        const nombreUsuario = `${user.terceroNombre1} ${user.terceroNombre2} ${user.terceroApellido1} ${user.terceroApellido2}`;
        const solicitud = this.props.solicitud;

        const descripcion = `<h2>Mensaje enviado por: ${nombreUsuario} </h2>
                        <br>
                        ${this.state.mensaje}
                        `;
        const params = {
            solicitudPasoId: solicitud.solicitud_paso_id,
            descripcion
        };
        const data = await Api.post(`${Env.UrlBackendCuentaNueva}/solicitud-interaccion-paso/save-by-usuario`, params);
        if (data.success) {
            AppToast(data.message, true);
            this.props.onClose();
        } else {
            AppToast(data.message, false);
        }
    }

    render() {

        const {onClose} = this.props;

        return (
            <DialogContent style={{padding: '0px'}}>
                <AppBar style={{position: 'relative'}}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={onClose}
                                    aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                        <Typography variant="h6">
                            <b>Enviar Mensaje Gestor</b>
                        </Typography>

                    </Toolbar>
                </AppBar>

                <div style={{padding: '30px'}}>
                    <CKEditor
                        activeClass="p10"
                        content={this.state.mensaje}
                        events={{
                            "change": this.onChangeCkEditor
                        }}
                    />

                    <div style={{textAlign:'center'}}>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            startIcon={<Icon>send</Icon>}
                            style={{margin: '10px'}}
                            onClick={this.guardar}
                        >
                            Enviar
                        </Button>
                    </div>


                </div>

            </DialogContent>
        );
    }
}

export default MensajeGestor